import nodeClient from "./node-client";

export const generateOTP = async (data) => {
  let result = null;
  result = await nodeClient
    .post(`/service/protected/v0/generate/otp`, data)
    .catch((reason) => reason.response);
  return result.data;
};

export const verifyOTP = async (data) => {
  let result = null;
  result = await nodeClient
    .post(`/service/protected/v0/verify/otp`, data)
    .catch((reason) => reason.response);
  return result.data;
};
